import styled, { css } from 'styled-components';
export const SkeletonWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
`;
export const IframeWrapper = styled.div `
  position: relative;

  display: flex;

  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
`;
export const Iframe = styled.iframe `
  position: absolute;

  opacity: 0;
  pointer-events: none;

  border: none;
  border-radius: var(--radius-brand);

  ${({ loaded }) => loaded &&
    css `
      --scale: min(
        calc(var(--containerHeight) / var(--previewHeight)),
        calc(var(--containerWidth) / var(--previewWidth))
      );

      position: absolute;
      top: 50%;
      left: 50%;

      display: inline-block;

      opacity: 1;
      overflow: hidden;
      transform-origin: 0 0;
      transform: scale(var(--scale)) translate(-50%, -50%);
      box-shadow:
        0 calc(0.125rem / var(--scale, 1)) calc(0.25rem / var(--scale, 1)) #1f21240d,
        0 calc(0.0625rem / var(--scale, 1)) calc(0.375rem / var(--scale, 1)) #1f212426;
      transition: opacity var(--p-motion-duration-100) var(--p-motion-ease)
        var(--p-motion-duration-50);

      height: calc(var(--previewHeight) * 0.0625rem);
      width: calc(var(--previewWidth) * 0.0625rem);

      border-radius: calc(var(--p-border-radius-100) / var(--scale));
    `}
`;
